import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { GlobalEventsManager } from '../../app-global-events-manager';
import { FormGroup, FormControl, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { WorkerService } from '../service/worker.service';
import { TranslateService } from '@ngx-translate/core';
// jQuery Sign $
declare let $: any;

@Component({
  selector: 'app-worker-registration',
  templateUrl: './worker-registration.component.html',
  styleUrls: ['./worker-registration.component.scss']
})
export class WorkerRegistrationComponent implements OnInit {
  // tslint:disable-next-line:no-inferrable-types
  isThirdStep: boolean = false;
  // tslint:disable-next-line:no-inferrable-types
  isFourthStep: boolean = false;
  invalidValidationMsg: string;
  loaderActivate: boolean;
  registerUser: any = {};
  agreementfilter: boolean;
  // tslint:disable-next-line:no-inferrable-types
  agreementagreed: string = 'No';
  @ViewChild('termsandconditions') openTermsAndConditionModal: ElementRef;
  @ViewChild('registerform') reportworkerform: NgForm;

  constructor(private globalEventsManager: GlobalEventsManager, private workerService: WorkerService,
     private router: Router, private route: ActivatedRoute, private translate: TranslateService) {
    this.route.params.subscribe((params) => {
      if (navigator.userAgent.match('/iPhone/i') || navigator.userAgent.match('/iPad/i')) {
        //  'yossosellerapp://worker/registration/3ykd95m6an0gw7uv'
        window.location.href = 'yossosellerapp://worker/registration/' +  params.token;
     } else {
        this.getWorkerInformation(params.token);
      }
    });
  }

  verificationForm = new FormGroup({
    verficationCode: new FormControl()
  });

  ngOnInit() {
    this.globalEventsManager.showNavBar(false);
    this.isThirdStep = true;
  }

  // Call the Token and Get the Main Worker Emails
  getWorkerInformation(token: string): void {
    this.loaderActivate = true;
    this.workerService.postValidateToken(token).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res === -14) {
        this.invalidValidationMsg = 'Invalid link, cannot register with this link';
        // this.translate.get('Register.EmailExists').subscribe(error => {
        //   this.invalidValidationMsg = error;
        // });
      } else if (res === 'UsernameExistsException') {
        // this.invalidValidationMsg = 'Already exist the user';
        this.translate.get('Register.EmailExists').subscribe(error => {
          this.invalidValidationMsg = error;
        });
      } else {
        this.registerUser.username = res;
      }
    }, err => {
      console.log(err);
    });
  }

  onFilterChange(eve: any) {
    if (eve) {
     // this.agreementagreed = 'Yes';
     // this.agreementfilter = true;
      $(this.openTermsAndConditionModal.nativeElement).modal('show');
    }else {
      this.agreementagreed = 'No';
      this.agreementfilter = false;
    }
  }

  // Decline Terms and Condition
  declineTermsandcondition() {
    this.reportworkerform.form.get('agreementfilter').setValue(false);
   // this.agreementfilter = false;
     this.agreementagreed = 'No';
    $(this.openTermsAndConditionModal.nativeElement).modal('hide');
  }

  // Accept the terms and conditions
  acceptTermsandcondition(): void {
    this.agreementfilter = true;
    this.agreementagreed = 'Yes';
    this.invalidValidationMsg = '';
    $(this.openTermsAndConditionModal.nativeElement).modal('hide');
  }

  // Save Registration Part
  save(model: any, isValid: boolean) {
    this.invalidValidationMsg = '';
    // call API to save customer
    if (!isValid) {
      this.translate.get('Register.Allfieldsrequired').subscribe(error => {
        this.invalidValidationMsg = error;
      });
      return;
    }
    if (!this.agreementfilter) {
      this.translate.get('Register.Pleaseaccepttermsconditions').subscribe(error => {
        this.invalidValidationMsg = error;
      });
      return;
    }

    this.loaderActivate = true;
    // tslint:disable-next-line:prefer-const
    let registermodal = {
      worker_email: this.registerUser.username,
      password: model.password
    };
    this.workerService.workerregistration(registermodal).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res === 200) {
        this.isThirdStep = false;
        this.isFourthStep = true;
        // this.userRegistrationService.register(this.user, this);
      } else if (res === 'InvalidPasswordException') {
        this.translate.get('Register.InvalidPassword').subscribe(error => {
          this.invalidValidationMsg = error;
        });
        // this.invalidValidationMsg = 'Invalid Password(min - 6 characters,upppercase, lowercase and special character).';
      } else if (res === 'InternalErrorException') {
        this.invalidValidationMsg = 'This exception is thrown when Back end encounters an internal error.';
      } else if (res === 'CodeDeliveryFailureException') {
        this.invalidValidationMsg = 'when a verification code fails to deliver successfully.';
      } else if (res === 'UsernameExistsException') {
        this.invalidValidationMsg = 'Already registered';
      } else if (res === 'InvalidParameterException') {
        this.invalidValidationMsg = 'Invalid Parameter.';
      }else {
        this.invalidValidationMsg = 'Invalid Parameter.';
      }
    }, err => {
      console.log(err);
    });

  }

  onFormSubmit() {
    this.invalidValidationMsg = '';
    // tslint:disable-next-line:prefer-const
    let verificationcode = this.verificationForm.get('verficationCode').value;
    if (verificationcode == null || verificationcode === '' ) {
      // this.invalidValidationMsg = 'Verification Code is required';
      this.translate.get('Register.VerificationCoderequired').subscribe(error => {
        this.invalidValidationMsg = error;
      });
      return;
    }
    this.loaderActivate = true;
    this.workerService.confirmEmailVerification(this.registerUser.username, verificationcode).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res === 200) {
        this.router.navigate(['/login']);
        this.loaderActivate = false;
      } else if (res === 'CodeMismatchException') {
        this.invalidValidationMsg = 'Ogiltigt verifieringskod';
      }else if (res === 'ExpiredCodeException') {
        this.invalidValidationMsg = 'Ogiltigt verifieringskod';
      }else if (res === 'UserNotFoundException') {
        this.invalidValidationMsg = 'User coudnot found.';
      } else {
        this.invalidValidationMsg = 'Ogiltigt verifieringskod';
      }

    }, err => {
      this.invalidValidationMsg = 'Ogiltigt verifieringskod';
    });


  }

  // Move By tag Click
  moveTags(tagname: string): void {
    if (tagname === 'isThirdStep') {
        // this.isThirdStep = true;
       // this.isFourthStep = false;
    }
  }

    // Go to Login
    goToLogin(): void {
      this.router.navigate(['/login']);
    }

}



// WEBPACK FOOTER //
// ./src/app/worker/worker-registration/worker-registration.component.ts